import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import Breadcrumb from "../../../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../../../App/State/Slices/SelectedCareersClientSlice";
import TabbedView from "../../../../App/Components/TabbedView/TabbedView";
import RsvpPage from "./Rsvp/RsvpPage";
import { Redirect, useLocation } from "react-router-dom";
import EventDetailsPage from "./EventDetails/EventDetailsPage";

function EventTabs() {
  const useStyles = makeStyles((theme) => ({
    root: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    autocomplete: {
      width: "35%",
      paddingBottom: "20px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    hint: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: "auto",
      marginRight: "auto",
      width: "300px",
      height: "300px",
      fontSize: "32px",
      textAlign: "center",
      color: "rgba(0,0,0,.6)",
    },
  }));

  const classes = useStyles();
  let location = useLocation();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const [clientId, setClientId] = useState("");
  const [eventId, setEventId] = useState("");

  useEffect(() => {
    if (location.state !== null && location.state !== undefined) {
      setClientId(location.state.clientId);
      setEventId(location.state.id);
    }
  }, []);

  if (location.state === null || location.state === undefined) {
    return <Redirect to="/events" />;
  }

  if (selectCareersClient.id !== clientId && clientId !== "") {
    return <Redirect to="/events" />;
  }

  const tabs = [
    {
      title: "Event",
      component: <EventDetailsPage clientId={clientId} eventId={eventId} />,
    },
    { title: "RSVP", component: <RsvpPage eventId={eventId} /> },
  ];

  return (
    <>
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">{selectCareersClient.shortName} Event</h1>
        <div className={classes.root}>
          {selectCareersClient === null ? (
            <div className={classes.hint}>
              <span>Select a client</span>
            </div>
          ) : (
            <TabbedView tabs={tabs} />
          )}
        </div>
      </div>
    </>
  );
}

export default EventTabs;
